import React from "react"
import autobind from "class-autobind"
import { EPayrollType, EPlanType, EPunchAuditAction, IPunchAudit, IRecord } from "../../models"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
import ImageLoader from "../misc/ImageLoader"
import MapLoader from "../../components/map/MapLoader"
import { FontIcon, Dialog, FlatButton } from "material-ui"
import EditPunchForm from "./EditPunchForm"
import PunchQuestionAnswerChip from "./punch_question_answer_detail/PunchQuestionAnswerChip"
import AuditTable from "../audit/AuditTable"
import LeftArrow from "material-ui/svg-icons/hardware/keyboard-arrow-left"
import RightArrow from "material-ui/svg-icons/hardware/keyboard-arrow-right"
import { grey400, amber500, orange900, green500, green50, deepOrange50 } from "material-ui/styles/colors"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AppStateStore from "../../stores/AppStateStore"
import * as api from "../../api"
import _ from "lodash"
import moment from "moment"
import * as timeHelper from "../../helpers/timeHelper"
import HierarchyJobTimezoneStr from "../common/HierarchyJobTimezoneStr"

interface IProps {
    punchId: string
    punchRecords: IRecord[]
    handleClose(changed: boolean): void
}
interface IState {
    punchId: string
    loadingPayrollLock: boolean
    payrollLocked: boolean
    punchRecords: IRecord[]
}
enum ESuspensePunchReviewType {
    Review,
    Rejected,
    Deleted,
    Accepted
}

export default class SuspensePunchReviewDialog extends React.Component<IProps, IState> {
    private changed = false
    constructor(props: IProps) {
        super(props)
        this.state = {
            punchId: props.punchId,
            loadingPayrollLock: true,
            payrollLocked: false,
            punchRecords: _.cloneDeep(props.punchRecords)
        }
        autobind(this)
    }

    async componentDidMount() {
        const payrollLocked = await this.getPayrollLockStatus(this.state.punchId)
        this.setState({ loadingPayrollLock: false, payrollLocked })
    }

    async getPayrollLockStatus(punchId: string) {
        const suspensePunchRecord = this.state.punchRecords.find(i => i.Punch.Id === punchId)
        const suspenseAuditNote = this.getSuspenseAuditNote(suspensePunchRecord)
        if (suspenseAuditNote.includes("locked pay period")) {
            const res = await api.getDayPayrollLockStatus(suspensePunchRecord.Punch.AccountId, { PayrollHierarchyItemId: suspensePunchRecord.Punch.PayrollHierarchyItemId, PayrollPayGroupId: suspensePunchRecord.Punch.PayrollPayGroupId }, suspensePunchRecord.Punch.DayGroupingTimeLocal, EPayrollType.Time)
            return res.data
        }
        else {
            return false
        }
    }


    navigate(index) {
        this.setState({ loadingPayrollLock: true }, async () => {
            const punchRecord = this.state.punchRecords[index]
            const payrollLocked = await this.getPayrollLockStatus(punchRecord.Punch.Id)
            this.setState({ punchId: punchRecord.Punch.Id, loadingPayrollLock: false, payrollLocked })
        })
    }

    getSuspenseAuditNote(suspensePunchRecord: IRecord): string {
        const errorPunchAudits = suspensePunchRecord.Punch.PunchAudits.filter(i => [EPunchAuditAction.Error, EPunchAuditAction.AddMissingPunch, EPunchAuditAction.SuspenseTime, EPunchAuditAction.TimecardSequenceError].includes(i.PunchAuditAction))
        return errorPunchAudits.length > 0 ?
            errorPunchAudits[errorPunchAudits.length - 1].Note :
            ""
    }

    getSuspenseMessage(suspensePunchRecord: IRecord): string {
        const suspenseAuditNote = this.getSuspenseAuditNote(suspensePunchRecord)
        if (suspenseAuditNote.includes("punch count reached to limit for free account")) {
            return strings.formatString(strings.The_punch_count_reached_to_limit_for_free_account, suspensePunchRecord.UserFirstName, suspensePunchRecord.UserLastName, AccountStore.getCurrentAccount().BillingInfo.PlanType === EPlanType.Free ? strings.Upgrade.toLocaleUpperCase() : strings.ACCEPT) as string
        }
        if (suspenseAuditNote.includes("manually added from a device")) {
            const substr0 = suspenseAuditNote.split(".")
            let deviceName
            if (substr0[0]) {
                const substr1 = substr0[0].split("device")
                if (substr1[1]) {
                    deviceName = substr1[1]
                }
            }
            return strings.formatString(strings.add_missing_punch_suspense_message, suspensePunchRecord.UserFirstName, suspensePunchRecord.UserLastName, deviceName) as string
        }
        if (suspenseAuditNote.includes("requested to change time")) {
            const substr0 = suspenseAuditNote.split(".")
            let userName
            if (substr0[0]) {
                const substr1 = substr0[0].split(" requested")
                if (substr1[0]) {
                    userName = substr1[0]
                }
            }

            let timeChanging
            if (substr0[0]) {
                const substr1 = substr0[0].split("(")
                if (substr1[0]) {
                    const substr2 = substr1[1].split(")")
                    if (substr2[0]) {
                        timeChanging = substr2[0]
                    }
                }
            }

            let deviceName
            if (substr0[0]) {
                const substr1 = substr0[0].split("device")
                if (substr1[1]) {
                    deviceName = substr1[1]
                }
            }
            return strings.formatString(strings.mobile_update_punch_time_suspense_message, userName, timeChanging, deviceName) as string
        }
        if (suspenseAuditNote.includes("Punch level has been deleted")) {
            return strings.formatString(strings.delete_punch_level_suspense_message, suspensePunchRecord.UserFirstName, suspensePunchRecord.UserLastName) as string
        }
        if (suspenseAuditNote.includes("is not an active user")) {
            return strings.formatString(strings.inactive_user_suspense_message, suspensePunchRecord.UserFirstName, suspensePunchRecord.UserLastName) as string
        }
        if (suspenseAuditNote.includes("is a deleted user")) {
            return strings.formatString(strings.delete_user_suspense_message, suspensePunchRecord.UserFirstName, suspensePunchRecord.UserLastName) as string
        }
        if (suspenseAuditNote.includes("Device") && suspenseAuditNote.includes("deleted")) {
            return strings.formatString(strings.delete_device_suspense_message, suspensePunchRecord.UserFirstName, suspensePunchRecord.UserLastName) as string
        }
        if (suspenseAuditNote.includes("Clock Device") && suspenseAuditNote.includes("registered to inactive hierarchy")) {
            return strings.formatString(strings.deleted_hierarchy_registered_device_suspense_message, suspensePunchRecord.UserFirstName, suspensePunchRecord.UserLastName) as string
        }
        if (suspenseAuditNote.includes("locked pay period")) {
            return this.state.payrollLocked ?
                strings.formatString(strings.locked_pay_period_suspense_message_for_lock, moment(timeHelper.keepConvertUTCToLocal(suspensePunchRecord.Punch.DayGroupingTimeLocal)).format("MM/DD/YYYY")) as string :
                strings.formatString(strings.locked_pay_period_suspense_message_for_unlock, moment(timeHelper.keepConvertUTCToLocal(suspensePunchRecord.Punch.DayGroupingTimeLocal)).format("MM/DD/YYYY"), suspensePunchRecord.UserFirstName, suspensePunchRecord.UserLastName) as string
        }
        if (suspenseAuditNote.includes("PayType") && suspenseAuditNote.includes("is not valid for employee payroll")) {
            return strings.formatString(strings.invalid_paytype_suspense_message, suspensePunchRecord.UserFirstName, suspensePunchRecord.UserLastName) as string
        }
        if (suspenseAuditNote.includes("Punch hierarchy is not allowed")) {
            return strings.formatString(strings.invalid_punch_hierarchy_suspense_message, suspensePunchRecord.UserFirstName, suspensePunchRecord.UserLastName) as string
        }
        if (suspenseAuditNote.includes("Punch is incorrect against assigning jobs")) {
            return strings.formatString(strings.assigned_job_suspense_message, suspensePunchRecord.UserFirstName, suspensePunchRecord.UserLastName) as string
        }
        if (suspenseAuditNote.includes("Punch has not phase")) {
            return strings.formatString(strings.empty_phase_suspense_message, suspensePunchRecord.UserFirstName, suspensePunchRecord.UserLastName) as string
        }
        if (suspenseAuditNote.includes("Object reference not set to an instance of an object.")) {
            const suspenseAudit = suspensePunchRecord.Punch.PunchAudits.find(i => i.Note === "Object reference not set to an instance of an object.")
            if (suspenseAudit && suspenseAudit.PunchAuditAction === EPunchAuditAction.TimecardSequenceError) {
                return strings.Punch_is_in_suspense_due_to_pairing_error_Please_approve_or_reject
            }
        }
        return ""
    }

    render() {
        const suspensePunchRecord = this.state.punchRecords.find(i => i.Punch.Id === this.state.punchId)

        let timeString
        if (suspensePunchRecord) {
            timeString = moment(timeHelper.keepConvertUTCToLocal(suspensePunchRecord.Punch.DateTimeLocal)).format("h:mm:ssa MM/DD/YYYY")
            const roundedString = moment(timeHelper.keepConvertUTCToLocal(suspensePunchRecord.Punch.RoundedDateTimeLocal)).format("h:mm:ssa MM/DD/YYYY")
            if (suspensePunchRecord.Punch.RoundingRuleId) {
                timeString = roundedString + " " + strings.RoundedFrom + " " + timeString
            }
        }

        const indexNum = this.state.punchRecords.findIndex(i => i.Punch.Id === this.state.punchId)
        const showNavigation = this.state.punchRecords.length > 1
        const mobileUpdateTimeSuspense = suspensePunchRecord.Punch.ReviewDateTime && timeHelper.convertDefaultDateToNull(suspensePunchRecord.Punch.ReviewDateTime) ? true : false

        let suspensePunchReviewType: ESuspensePunchReviewType = ESuspensePunchReviewType.Review
        if (suspensePunchRecord.Punch.Deleted) {
            suspensePunchReviewType = ESuspensePunchReviewType.Deleted
        }
        else if (!suspensePunchRecord.Punch.Suspense) {
            suspensePunchReviewType = mobileUpdateTimeSuspense ? ESuspensePunchReviewType.Rejected : ESuspensePunchReviewType.Accepted
        }

        return (
            <Dialog
                open
                autoScrollBodyContent
                title={
                    <div style={{ paddingLeft: 24, paddingRight: 24, paddingTop: 10, paddingBottom: 10 }}>
                        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 5, height: 36 }}>
                            {!this.state.loadingPayrollLock &&
                                permissionHelper.hasPermission(AuthenticationStore.Permissions.PunchRecords.EditSuspense) &&
                                suspensePunchReviewType === ESuspensePunchReviewType.Review && [
                                    <FlatButton
                                        key="delete"
                                        label={mobileUpdateTimeSuspense ? strings.Reject : strings.DELETE}
                                        secondary
                                        onTouchTap={() => AppStateStore.setConfirmDialogContent({
                                            content: mobileUpdateTimeSuspense ?
                                                strings.Are_you_sure_you_want_to_reject_this_suspense_punch_time :
                                                strings.Are_you_sure_you_want_to_delete_this_suspense_punch,
                                            confirm: () => {
                                                this.changed = true
                                                AppStateStore.setProgressSnackbarContent("loading")
                                                api.deleteRejectSuspensePunches([this.state.punchId]).then(() => {
                                                    AppStateStore.setProgressSnackbarContent(null)
                                                    const punchRecords = _.cloneDeep(this.state.punchRecords)
                                                    const punchRecordIndex = punchRecords.findIndex(i => i.Punch.Id === this.state.punchId)
                                                    if (!mobileUpdateTimeSuspense) {
                                                        punchRecords[punchRecordIndex].Punch.Deleted = true
                                                    }
                                                    punchRecords[punchRecordIndex].Punch.Suspense = false
                                                    this.setState({ punchRecords })
                                                })
                                            }
                                        })}
                                        icon={<i className="fa fa-remove" />}
                                    />,
                                    AccountStore.getCurrentAccount().BillingInfo.PlanType === EPlanType.Free &&
                                        this.getSuspenseAuditNote(suspensePunchRecord).includes("punch count reached to limit for free account") ?
                                        <FlatButton
                                            key="upgrade"
                                            label={strings.Upgrade.toLocaleUpperCase()}
                                            primary
                                            onTouchTap={() => {
                                                AppStateStore.openAccountBillingDrawer()
                                                this.props.handleClose(false)
                                            }}
                                            icon={< i className="fa fa-check" />}
                                        /> :
                                        !(this.getSuspenseAuditNote(suspensePunchRecord).includes("locked pay period") && this.state.payrollLocked) &&
                                        <FlatButton
                                            key="accept"
                                            label={strings.ACCEPT}
                                            primary
                                            onTouchTap={() => AppStateStore.setConfirmDialogContent({
                                                content: strings.Are_you_sure_you_want_to_accept_this_suspense_punch,
                                                confirm: () => {
                                                    AppStateStore.setProgressSnackbarContent("loading")
                                                    api.acceptSuspensePunches([this.state.punchId]).then(res => {
                                                        const punchAudit: IPunchAudit = res.data[this.state.punchId]
                                                        if (punchAudit === null) {
                                                            this.changed = true
                                                            AppStateStore.setProgressSnackbarContent(null)
                                                            const punchRecords = _.cloneDeep(this.state.punchRecords)
                                                            const punchRecordIndex = punchRecords.findIndex(i => i.Punch.Id === this.state.punchId)
                                                            punchRecords[punchRecordIndex].Punch.ReviewDateTime = null
                                                            punchRecords[punchRecordIndex].Punch.Suspense = false
                                                            this.setState({ punchRecords })
                                                        }
                                                        else {
                                                            AppStateStore.setProgressSnackbarContent(`${strings.Failed_to_accept}: "${punchAudit.Note}"`)
                                                        }
                                                    })
                                                }
                                            })}
                                            icon={< i className="fa fa-check" />}
                                        />
                                ]
                            }
                        </div>
                        <div
                            style={{
                                background: suspensePunchReviewType === ESuspensePunchReviewType.Review ? amber500 : suspensePunchReviewType === ESuspensePunchReviewType.Accepted ? green500 : orange900,
                                color: suspensePunchReviewType === ESuspensePunchReviewType.Review ? orange900 : suspensePunchReviewType === ESuspensePunchReviewType.Accepted ? green50 : deepOrange50,
                                paddingLeft: 10,
                                paddingRight: 10,
                                paddingTop: 5,
                                paddingBottom: 5,
                                display: "flex",
                                justifyContent: "space-between"
                            }}
                        >
                            <div>
                                <div style={{ fontSize: 18, fontWeight: "bold" }}>
                                    {`${strings.Suspense_Punch.toUpperCase()}${suspensePunchReviewType === ESuspensePunchReviewType.Deleted ? ` - ${strings.Deleted.toUpperCase()}` : suspensePunchReviewType === ESuspensePunchReviewType.Rejected ? ` - ${strings.Rejected.toUpperCase()}` : suspensePunchReviewType === ESuspensePunchReviewType.Accepted ? ` - ${strings.Accepted.toUpperCase()}` : ""}`}
                                </div>
                                {!this.state.loadingPayrollLock &&
                                    <div style={{ fontSize: 15, lineHeight: "20px" }}>
                                        {this.getSuspenseMessage(suspensePunchRecord)}
                                    </div>
                                }
                            </div>
                            <div>
                                <span className="fa-stack" style={{ fontSize: 30 }}>
                                    <i className="fa fa-square-o fa-stack-2x" />
                                    <i className={`fa fa-${suspensePunchReviewType === ESuspensePunchReviewType.Review ? "warning" : suspensePunchReviewType === ESuspensePunchReviewType.Accepted ? "check" : "close"} fa-stack-1x`} />
                                </span>
                            </div>
                        </div>
                    </div>
                }
                contentStyle={{ width: showNavigation ? 900 : 800, maxWidth: "none" }}
                actions={
                    <FlatButton data-intercom-target={"Btn-Close-SuspensePunchReviewDialog"} label={strings.Close} primary onClick={() => this.props.handleClose(this.changed)} />
                }
            >
                <div style={{ paddingLeft: showNavigation ? 50 : 0, paddingRight: showNavigation ? 50 : 0 }}>
                    <div style={{ width: 500, fontSize: 12 }}>
                        {timeString}&nbsp;
                        <HierarchyJobTimezoneStr
                            hierarchyId={suspensePunchRecord.Punch.HierarchyItemId}
                            jobId={suspensePunchRecord.Punch.JobId}
                            utcTime={suspensePunchRecord.Punch.RoundingRuleId ? suspensePunchRecord.Punch.RoundedDateTime : suspensePunchRecord.Punch.DateTime}
                        />
                    </div>
                    {suspensePunchRecord.Punch.ImageS3Url ?
                        <div style={{ float: "right" }}>
                            <ImageLoader url={suspensePunchRecord.Punch.ImageS3Url} fixedHeight={150} key={suspensePunchRecord.Punch.Id} src={"/punches/image/" + suspensePunchRecord.Punch.ImageID} />
                        </div> :
                        suspensePunchRecord.Punch.DeferredPhotoUpload &&
                        <div style={{ float: "right", textAlign: "center", width: 175, height: 128, padding: 10, backgroundColor: "#efefef", border: "solid 1px #cccccc" }}>
                            <b>{strings.DefferedImageUploadTitle}</b>
                            <FontIcon className="fa fa-cloud-upload" style={{ fontSize: 60, color: "#cccccc" }} />
                            <p>{strings.DefferedImageUploadBody}</p>
                        </div>
                    }
                    {suspensePunchRecord.Punch.MetaData && suspensePunchRecord.Punch.MetaData.Latitude !== 0 && suspensePunchRecord.Punch.MetaData.Longitude !== 0 &&
                        <section style={{ height: 150, width: "100%" }}>
                            <MapLoader
                                locations={[
                                    {
                                        lat: suspensePunchRecord.Punch.MetaData.Latitude,
                                        lng: suspensePunchRecord.Punch.MetaData.Longitude
                                    }
                                ]}
                            />
                        </section>
                    }
                    {suspensePunchRecord.Punch.Note &&
                        <div style={{ margin: 10 }}>
                            <span style={{ fontSize: 16, fontWeight: "bold", marginRight: 10 }}>{`${suspensePunchRecord.UserFirstName} ${suspensePunchRecord.UserLastName} ${strings.Note}:`}</span>
                            <span style={{ fontSize: 12 }}>{suspensePunchRecord.Punch.Note}</span>
                        </div>
                    }
                    <div style={{ clear: "both" }} />
                    <div style={{ marginTop: 10 }}>
                        <EditPunchForm
                            readonly
                            punch={suspensePunchRecord.Punch}
                        />
                    </div>
                    <div style={{ padding: 10, borderTop: "solid 1px #cccccc", position: "relative" }}>
                        <div style={{ position: "absolute", right: 10, top: -40 }}>
                            <PunchQuestionAnswerChip
                                imageS3Url={suspensePunchRecord && suspensePunchRecord.Punch.ImageS3Url}
                                punchDateTimeLocal={suspensePunchRecord ? suspensePunchRecord.Punch.DateTimeLocal : null}
                                btn1Ids={suspensePunchRecord.Punch.Btn1Ids}
                                btn2Ids={suspensePunchRecord.Punch.Btn2Ids}
                            />
                        </div>
                        <AuditTable
                            audits={suspensePunchRecord.Punch.PunchAudits}
                            hierarchyId={suspensePunchRecord.Punch.HierarchyItemId}
                            jobId={suspensePunchRecord.Punch.JobId}
                        />
                    </div>
                </div>
                {indexNum !== 0 &&
                    <LeftArrow
                        style={{ width: 75, height: 75, left: 0, cursor: "pointer", position: "absolute", top: 370, fill: grey400 }}
                        onClick={() => this.navigate(indexNum - 1)}
                    />
                }
                {indexNum !== this.state.punchRecords.length - 1 &&
                    <RightArrow
                        style={{ width: 75, height: 75, right: 0, cursor: "pointer", position: "absolute", top: 370, fill: grey400 }}
                        onClick={() => this.navigate(indexNum + 1)}
                    />
                }
            </Dialog >
        )
    }
}
